import { render, staticRenderFns } from "./MultipleMarkAsDoneDisposal.vue?vue&type=template&id=182dcd47"
import script from "./MultipleMarkAsDoneDisposal.vue?vue&type=script&lang=js"
export * from "./MultipleMarkAsDoneDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports